import { useState } from 'react';

import { useDeepEffect } from 'hooks/useDeepEffect';
import { searchAlgoliaFetchRecommendedJobs } from 'modules/search/algolia/fetch/searchAlgoliaFetchRecommendedJobs';
import { SearchAlgoliaRecommendedListingHit } from 'modules/search/algolia/types/SearchAlgoliaRecommendedListingHit';
import { SearchLocation } from 'modules/search/types/SearchLocation';
import { log } from 'utils/logging';

type Props = {
  searchLocation: Partial<SearchLocation> &
    Pick<SearchLocation, 'latitude' | 'longitude'>;
  options: {
    onlyWithLogo?: boolean;
    jobTitle?: string;
    familyId?: string;
  };
};

type ResultsType = 'Job Family' | 'Text Query' | 'Location' | null;
type FiltersUsed = {
  searchLocation?: Partial<SearchLocation> &
    Pick<SearchLocation, 'latitude' | 'longitude'>;
  jobTitle?: string;
  familyId?: string;
};

export function useSearchAlgoliaSalaryRecommendedJobs({
  searchLocation,
  options: { onlyWithLogo, familyId, jobTitle },
}: Props): {
  filtersUsed: FiltersUsed;
  resultsType: ResultsType;
  recommendedJobs: SearchAlgoliaRecommendedListingHit[];
  queryId: number;
} {
  const [recommendedJobs, setRecommendedJobs] = useState<
    SearchAlgoliaRecommendedListingHit[]
  >([]);
  const [resultsType, setResultsType] = useState<ResultsType>();
  const [filtersUsed, setFiltersUsed] = useState<FiltersUsed>();
  const [queryId, setQueryId] = useState(0);
  useDeepEffect(() => {
    let resultsTypeToSet: ResultsType = null;
    let filters = {};
    const handleRecommendedJobs = async () => {
      resultsTypeToSet = 'Job Family';
      filters = {
        searchLocation,
        familyId,
      };
      let hits = await searchAlgoliaFetchRecommendedJobs({
        searchLocation,
        options: {
          // @ts-expect-error TS(2322): Type 'boolean | undefined' is not assignable to ty... Remove this comment to see the full error message
          onlyWithLogo,
          familyId,
        },
      });

      if (hits.length < 4) {
        resultsTypeToSet = 'Text Query';
        filters = {
          searchLocation,
          jobTitle,
        };
        hits = await searchAlgoliaFetchRecommendedJobs({
          searchLocation,
          options: {
            // @ts-expect-error TS(2322): Type 'boolean | undefined' is not assignable to ty... Remove this comment to see the full error message
            onlyWithLogo,
            jobTitle,
          },
        });
      }

      if (hits.length < 4) {
        resultsTypeToSet = 'Location';
        filters = {
          searchLocation,
        };
        hits = await searchAlgoliaFetchRecommendedJobs({
          searchLocation,
          options: {
            // @ts-expect-error TS(2322): Type 'boolean | undefined' is not assignable to ty... Remove this comment to see the full error message
            onlyWithLogo,
          },
        });
      }

      if (hits.length < 4) {
        setQueryId(queryId + 1);
        setResultsType(null);
        setRecommendedJobs([]);
      } else {
        setQueryId(queryId + 1);
        setFiltersUsed(filters);
        setResultsType(resultsTypeToSet);
        setRecommendedJobs(hits);
      }
    };

    handleRecommendedJobs().catch((e) => log.error(e));
  }, [jobTitle, searchLocation, onlyWithLogo, familyId]);

  // @ts-expect-error TS(2322): Type 'ResultsType | undefined' is not assignable t... Remove this comment to see the full error message
  return { resultsType, recommendedJobs, queryId, filtersUsed };
}
